<template>
    <div class="mvt-map-static">
        <img ref="img" :src="placeholderUrl" :loading="eager ? 'eager' : 'lazy'" :fetchpriority="eager ? 'high' : 'auto'" :alt="alt" v-once @error="onMapImgError">
        <slot></slot>
    </div>
</template>
<script src="./mvt-mapstatic.js"></script>
<style lang="scss">
@use "./mvt-mapstatic.scss" as *;
</style>
